export default __webpack_public_path__ + "static/media/portfoliotemplate.0c6e187f.png";